import React from 'react'
import FinanceStatusBadge from '../FinanceStatusBadge'
import FinanceCard from '../foundation/FinanceCard'
import FinanceInfoGrid from '../foundation/FinanceInfoGrid'
import FinanceInfoItem from '../foundation/FinanceInfoItem'

interface Props {
  title: string
  status?: string | null
  fields: { label: React.ReactNode; value: React.ReactNode }[]
  description?: React.ReactNode
}

const FinanceStatePanel: React.FC<Props> = ({
  title,
  status,
  fields,
  description,
}) => (
  <FinanceCard title={title} description={description}>
    <FinanceInfoGrid $columns={3}>
      <FinanceInfoItem
        label="Status"
        value={<FinanceStatusBadge status={status || 'inactive'} />}
      />
      {fields.map((field, index) => (
        <FinanceInfoItem
          key={`${index}-${String(field.label)}`}
          label={field.label}
          value={field.value}
        />
      ))}
    </FinanceInfoGrid>
  </FinanceCard>
)

export default FinanceStatePanel
